// extracted by mini-css-extract-plugin
export default {"ticketState":"ticketState__viemDbWHuMjx"};